export default __webpack_public_path__ + "static/media/bkg--interiors-1.a1b68c71.jpg";